import styled from 'styled-components'
import { NextSeo } from 'next-seo'
import { useTranslation } from '@pancakeswap/localization'
import { useRouter } from 'next/router'
import { DEFAULT_META, getCustomMeta } from 'config/constants/meta'
import { OG_HEIGHT, OG_WIDTH } from 'config/constants/seo'
import Container from './Container'

const StyledPage = styled(Container)`
  width: 100%;
  min-height: calc(100vh - 64px);
  padding-top: 16px;
  padding-bottom: 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding-top: 24px;
    padding-bottom: 24px;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    padding-top: 32px;
    padding-bottom: 32px;
  }
`

export const PageMeta: React.FC<React.PropsWithChildren> = () => {
  const {
    t,
    currentLanguage: { locale },
  } = useTranslation()
  const { pathname } = useRouter()

  const pageMeta = getCustomMeta(pathname, t, locale)

  if (!pageMeta) {
    return null
  }

  const { description, image, url } = { ...DEFAULT_META, ...pageMeta }

  // the share card is a JPEG the app serves itself (/og/<slug>.jpg, 1200 x 630); canonical and og:url are production URLs
  return (
    <NextSeo
      title={pageMeta.title}
      description={description}
      canonical={url}
      openGraph={{
        type: 'website',
        siteName: 'CADINUdex',
        description,
        ...(url && { url }),
        ...(image && { images: [{ url: image, width: OG_WIDTH, height: OG_HEIGHT, alt: pageMeta.title, type: 'image/jpeg' }] }),
      }}
      twitter={{ cardType: 'summary_large_image' }}
    />
  )
}

const Page: React.FC<React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>> = ({ children, ...props }) => {
  return (
    <>
      <PageMeta />
      <StyledPage {...props}>{children}</StyledPage>
    </>
  )
}

export default Page
